document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".start-page")) return;
  _paq.push(['trackEvent', 'Navigation', 'start']);
});
